import classNames from 'classnames';

import SubscriptionClubSummary from './subscription/ClubSummary';
import ManualProductSummary from './subscription/ManualProductSummary';
import TraditionalClubSummary from './traditional/ClubSummary';

const ClubSummary = (props) => {
  const {
    club,
    clubPackage,
    clubMembership,
    isSummaryVisibleOnMobile,
    page,
    clubSignup
  } = props;
  return (
    <section
      className={classNames(
        'c7-checkout-summary',
        isSummaryVisibleOnMobile && 'c7-visible'
      )}
    >
      <h2>{club.title}</h2>
      {club.type === 'Traditional' && (
        <TraditionalClubSummary
          clubPackage={clubPackage}
          clubMembership={clubMembership}
          club={club}
          page={page}
        />
      )}
      {club.type === 'Controlled Subscription' && (
        <ManualProductSummary club={club} clubSignup={clubSignup} page={page} />
      )}
      {club.type === 'Subscription' && (
        <>
          {club.subscription.productSelection === 'Manual' && (
            <ManualProductSummary
              club={club}
              clubSignup={clubSignup}
              page={page}
            />
          )}
          {club.subscription.productSelection === 'Automatic' && (
            <SubscriptionClubSummary
              club={club}
              clubMembership={clubMembership}
              page={page}
            />
          )}
        </>
      )}
    </section>
  );
};

export default ClubSummary;
